import React from 'react';
import BreadCrumbNav from './BreadCrumbNav';
import EmpanelmentContent from './EmpanelmentContent';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import PreLoader from './PreLoader';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';

const Empanelment = () => {

  return (
    <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Empanelment" />

        <EmpanelmentContent />        

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default Empanelment;